import { Button, Group, TextInput } from '@mantine/core'
import { isNotEmpty, useForm } from '@mantine/form'
import { FormattedMessage, useIntl } from 'react-intl'

export type FormValues = {
  name: string
}

type UpdateModelFormProps = {
  initialValues: FormValues
  onCancel: () => void
  onSubmit: (formValues: FormValues) => void
}

export const UpdateModelForm = ({
  initialValues,
  onCancel,
  onSubmit
}: UpdateModelFormProps) => {
  const intl = useIntl()

  const form = useForm({
    initialValues: {
      name: initialValues.name
    },

    validate: {
      name: isNotEmpty(intl.formatMessage({ id: 'models.enterModelName' }))
    }
  })

  return (
    <form noValidate onSubmit={form.onSubmit((values) => onSubmit(values))}>
      <TextInput
        label={intl.formatMessage({ id: 'models.modelName' })}
        mb="xl"
        autoFocus
        data-autofocus // required for auto focus inside the modal
        {...form.getInputProps('name')}
      />

      <Group justify="end">
        <Button miw={120} variant="default" onClick={onCancel}>
          <FormattedMessage id="cancel" />
        </Button>

        <Button type="submit">
          <FormattedMessage id="models.update" />
        </Button>
      </Group>
    </form>
  )
}
